import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles, Button, Grid, Typography, IconButton } from '@material-ui/core';
import SelectBox from '../../CustomizedUIs/CustomSelectBox';
import { useTranslate, useDataProvider, usePermissions } from 'react-admin';
import { getFileNameWithoutExtension } from '../../utils';
import SelectBoxTemplateList from '../select-template-list';
import UploadFilesPopup from './upload-files-popup';
import { usePopupState, bindToggle } from 'material-ui-popup-state/hooks';
import icAttachSelected from '../../assets/icons/ic_attach_selected.png';
import icAttachment from '../../assets/icons/ic_attachment.png';
import CustomPopoverArrow from '../../CustomizedUIs/CustomPopoverArrow';
import DialogChooseFile from '../../file-management/file-management-dialog';
import { isAudio, isImage, isVideo } from '../../utils';

const useStyles = makeStyles(() => ({
    display: {
        display: 'none',
    },
    titleRadio: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#ffffff",
    },
    borderImage: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '13px 16px 13px 16px',
        backgroundColor: '#65a9db',
        "&:hover": {
            backgroundColor: '#237fc2'
        },
    }
}));

function SelectBoxTone({ selectedTone, setSelectedTone }) {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const { permissions, loaded } = usePermissions();
    const classes = useStyles();
    const popupState = usePopupState({ variant: 'popper', popupId: 'attachments' });
    const [isAttachOpen, setAttachOpen] = useState(false);
    const [categories, setCategories] = useState([]);
    const [url, setUrl] = useState('')
    // STATE
    const [open, setOpen] = useState(false);
    const [list, setList] = useState([]);
    // END STATE

    const onUploadFilesSuccess = (categories) => {
        setAttachOpen(false);
        getCategory(categories);
        getListToneAlarm();
        popupState.close();
    }
    const getCategory = (newCategories) => {
        if (newCategories) {
            setCategories([...categories, ...newCategories]);
        }
    }

    const onChangeAlarmTone = (audio) => {
        setSelectedTone(audio);
        setOpen(false);
    }

    const getListToneAlarm = () => {
        dataProvider('GET_LIST', "category/alarmtone", {
            filter: {},
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'id', order: 'ASC' },
        }).then(({ data }) => {
            setList(data);
        }).catch(error => {
            console.error('getListToneAlarm:', error)
        });
    }

    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    })

    const handleClose = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            format: '',
            setResponse: null
        })
    }
    const handleChoose = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            format: '',
            setResponse: null
        })
        setOpen(false)
    }

    const handleOpenFileDialog = () => {
        setOpenFile({
            status: true,
            defaultId: 7,
            format: isAudio,
            setResponse: setSelectedTone,
        })
    }

    useEffect(() => {
        getListToneAlarm();
    }, []);

    if (!loaded) return null
    return (
        <Box mt={4} mx={2.5}>
            <SelectBox label={translate(`pos.alarm.alarmTone`)} alignItems="center" open={open}
                value={selectedTone ? getFileNameWithoutExtension(selectedTone.name) : ''}
                handleClick={() => setOpen(!open)}
                CreateBox={
                    <Box display='flex' style={{ boxShadow: '0 1px 10px 0 rgba(0, 0, 0, 0.3)', backgroundColor: '#237fc2' }} px={2} py={1}>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center">
                            <Grid item >
                                <Box display='flex' borderRadius={4} alignItems='center'>
                                    <IconButton
                                        variant="outlined"
                                        color='primary'
                                        style={{ marginRight: '10px', padding: 'unset' }}
                                        {...bindToggle(popupState)}
                                    >
                                        {
                                            isAttachOpen ?
                                                <img src={icAttachSelected} width={27} height={27} /> : <img src={icAttachment} height={27} width={27} />
                                        }
                                    </IconButton>
                                    <CustomPopoverArrow
                                        zIndex={1500}
                                        popupState={popupState}
                                        placement='left-end'
                                    >
                                        <UploadFilesPopup
                                            onUploadFilesSuccess={onUploadFilesSuccess}
                                            parentId={9}        // default attachments folder id
                                            close={() => {
                                                setAttachOpen(false);
                                                popupState.close();
                                            }}
                                            getCategory={getCategory}
                                            acttachmentStyle={{
                                                maxHeight: 260,
                                                overflow: 'auto'
                                            }}
                                        />
                                    </CustomPopoverArrow>
                                    <Typography className={classes.titleRadio} >{translate('resources.alarm.addsound').toUpperCase()}</Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <Button onClick={() => handleOpenFileDialog()} className={classes.borderImage}>{translate('resources.alarm.browsefile').toUpperCase()}</Button>
                                </Box>
                            </Grid>
                        </Grid>
                        <DialogChooseFile
                            formats={openFile.format}
                            defaultId={openFile.defaultId}
                            open={openFile.status}
                            pickerMode='pickMediaOnly'
                            handleClose={handleClose}
                            setChooseValue={openFile.setResponse}
                            handleChoose={handleChoose}
                            isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                        />

                    </Box>

                }
            >
                <SelectBoxTemplateList list={list} onChangeTemplate={onChangeAlarmTone} />
            </SelectBox>
        </Box>
    );
}

SelectBoxTone.propTypes = {
    selectedTone: PropTypes.object,
    setSelectedTone: PropTypes.func.isRequired
};

export default SelectBoxTone;

